import type {DefaultOptions} from 'shared/value-editors/types';
import type {
    InlineRecordSearchValueEditorLocalizations,
    InlineRecordSearchValueEditorOptions
} from 'src/features/record/inline-record-search/types';

/**
 * @ngdoc constant
 * @name INLINE_RECORD_SEARCH_VALUE_EDITOR_DEFAULT_OPTIONS
 * @module portaro.record.inline-record-search
 *
 * @description
 * For description see {@link InlineRecordSearchValueEditorOptions}
 *
 * ```
 * {
 *      searchParams: undefined,
 * }
 * ```
 */
export const INLINE_RECORD_SEARCH_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<InlineRecordSearchValueEditorOptions> = {
    searchParams: undefined,
    searchType: 'q'
};

/**
 * @ngdoc constant
 * @name INLINE_RECORD_SEARCH_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.record.inline-record-search
 *
 * @description
 * ```
 * {
 *      delete: 'Delete'
 * }
 * ```
 */
export const INLINE_RECORD_SEARCH_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<InlineRecordSearchValueEditorLocalizations>({
    delete: 'Delete',
    description: '',
});